/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class SupportedSizeBaseDto {
    id: string | null;
    createdOn: Date;
    createdBy: string | null;
    modifiedOn: Date | null;
    modifiedBy: string | null;
    name: string;
    width: number | null;
    height: number | null;
    priceCalculationStrategyId: string | null;
}
